<template>
    <div>
		<div v-if="$route.name === 'report-evaluation'">
			<title-header>
				<v-layout row wrap justify-space-between align-center>
					<v-layout row wrap justify-start align-center>
						<v-flex xs3 tw-mx-2>
							<label :style="`color:${$appColors.success}`">
								Seleccione el Área
								<v-select
									label="Área"
									class="select-core"
									hide-details
									:menu-props="{ contentClass: 'type-select-content' }"
									height="37"
									autocomplete
									outline
									single-line
									:items="areas"
									item-value="id"
									item-text="name"
									v-model="area"
									@input="getAreas($event)"
								></v-select>
							</label>
						</v-flex>
						<v-flex xs3 tw-mx-2>
							<label :style="`color:${$appColors.success}`">
								Seleccione el Colaborador
								<v-select
									label="Nombre"
									class="select-core"
									hide-details
									:menu-props="{ contentClass: 'type-select-content' }"
									height="37"
									autocomplete
									clearable
									outline
									single-line
									:items="employees"
									item-value="id"
									item-text="fullName"
									v-model="employee"
									return-object
									@input="getEmployee($event)"
								></v-select>
							</label>
						</v-flex>
					</v-layout>
					<div class="tw-flex tw-mr-10">
						<app-tooltip-button
							img="/static/img/statistics.svg"
							text="Dashboards"
							@click-icon="handleDashboard"
						/>
						<download-btn
							alt="Descargar reporte en Excel"
							:height="23"
							url-image="/static/img/icons/excel.webp"
							@download-item="downloadReport({ type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' })"
						></download-btn>
					</div>
					<div class="wrapper-btns">
						<v-btn color="primary btn-action" @click="goToBack">
							<img
								src="/static/img/icons/btn-right-arrow.webp"
								alt="Atrás"
								class="mr-4"
							/>
							Atrás
						</v-btn>
					</div>
				</v-layout>
			</title-header>
			<v-layout wrap mt-5 v-if="employee && employees.length > 0 && showCard">
				<v-flex xs6 mb-5 px-2
				>
					<card-tool
						big
						:data="employee"
						:card-reverse="employee.numEmployees === 0 && employee.numTotEvaluators === 0"
						@open-evaluators="openEvaluators"
						@view-summary="goToEvaluation"/>
				</v-flex>
			</v-layout>
			<modal
				:dialog="dialog"
				:create="false"
				title="cerrar"
				@close-modal="closeModal"
				@create-employee="closeModal">
				<div class="evaluators-table" :style="`border: 1px solid ${$appColors.gray}`">
					<table-modal
						:columns="columns"
						:rows="rows">
						<template slot="rows" width="1" slot-scope="props">
							<td	:style="`color:${$appColors.secondary}`">
								{{ props.row.name ? props.row.name : null }} {{ props.row.lastName ? props.row.lastName : null }}
							</td>
							<td  :style="`color:${$appColors.secondary}`">
								{{ props.row.documentNumber ? props.row.documentNumber : null}}
							</td>
							<td  :style="`color:${$appColors.secondary}`">
								{{ props.row ? setGender(props.row.gender) : null}}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{  props.row ? props.row.email : null }}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{ props.row.group ? props.row.group.name 	: null }}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								{{ props.row.job ? props.row.job.name 	: null }}
							</td>
							<td :style="`color:${$appColors.secondary}`">
								<v-checkbox
									v-if="props.row.status == 2"
									input-value="true"
									label="Realizado"
									value
									disabled
								></v-checkbox>
								<v-checkbox
									v-if="props.row.status == 1"
									label="No realizado"
									value
									disabled
								></v-checkbox>
							</td>
						</template>
					</table-modal>
				</div>
			</modal>
		</div>
    </div>
</template>

<script>
import titleHeader from '@/components/diagnosis/title-header';
import cardTool from '@/components/p-evaluation/card-tool';
import helper from '@/shared/helper';
import downloadBtn from '@/components/diagnosis/download-btn';
import tableModal from '@/components/configuration/assign-area';
import modal from '@/components/configuration/open-modal';
import bus from '@/bus/app-bus';
import { MAIN_LOADER_EVENT } from '@/modules/shared/components/ui/p-main-loader.constants';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';

const { generateBlob, showDownloadDialog, getLocalData } = helper;

function created() {
}

function goToBack() {
	this.goTo('list-process');
}

async function loadData() {
	try {
		const { data: response } = await this.$httpPraktiko.get('groups');
		this.areas = response;
	} catch (error) {
		this.showGenericError();
	}
}

async function loadDetails(id = null) {
	try {
		const { data: details } = await this.$httpPraktiko.get(`process/detail/${this.process.id}`);
		this.areas = details.groups && details.groups.areas ? details.groups.areas : [];
		const dataEmployees = details.processEmployees ? details.processEmployees : [];
		const getEmployees = dataEmployees.map(dE => ({
			employeeId: dE.employeeId,
			groupId: dE.groupId,
			jobId: dE.jobId,
		}))
			.filter(f => f.groupId === id)
			.filter((dE, index, self) =>
				index === self.findIndex(e =>
					e.employeeId === dE.employeeId &&
					e.groupId === dE.groupId &&
					e.jobId === dE.jobId,
				));
		if (id && getEmployees.length > 0) {
			const { data: newEmployees } = await this.$http.post('register/get-employees-history',
				{ conditions: getEmployees });
			this.employees = newEmployees.map((item) => {
				const newItem = { ...item };
				const find = dataEmployees.find(e => e.employeeId === item.id);
				newItem.fullName = `${item.name} ${item.lastName}`;
				newItem.evaluators = find ? find.evaluators : {};
				newItem.additionalInformation = find ? find.additionalInformation : null;
				newItem.flagActive = find ? find.flagActive : null;
				newItem.createdAt = find ? find.createdAt : null;
				newItem.deletedAt = find ? find.deletedAt : null;
				return newItem;
			});
			this.showCard = false;
		} else {
			this.employees = [];
			this.employee = null;
			this.showCard = false;
		}
	} catch (error) {
		this.showGenericError();
	}
	// if (id) {
	// 	const params = {
	// 		groupId: id,
	// 	};
	// 	try {
	// 		const { data: response } = await this.$httpPraktiko.get('employee', { params });
	// 		this.employees = response;
	// 		this.employees = this.employees.map((item) => {
	// 			const newItem = { ...item };
	// 			const find = dataEmployees.find(e => e.employeeId === item.id);
	// 			newItem.fullName = `${item.name} ${item.lastName}`;
	// 			newItem.evaluators = find ? find.evaluators : {};
	// 			newItem.additionalInformation = find ? find.additionalInformation : null;
	// 			newItem.flagActive = find ? find.flagActive : null;
	// 			newItem.createdAt = find ? find.createdAt : null;
	// 			newItem.deletedAt = find ? find.deletedAt : null;
	// 			return newItem;
	// 		});
	// 		if (this.employees.length === 0) {
	// 			this.employee = null;
	// 		}
	// 	} catch (error) {
	// 		this.showGenericError();
	// 	}
	// }
}

function getAreas(id) {
	// this.employeesFilter = this.employees.filter(f => f.groupId === id);
	this.loadDetails(id);
}

function getEmployee(emp) {
	this.employee = emp;
	const numEmployees = emp && emp.evaluators && emp.evaluators.employees ?
		emp.evaluators.employees.filter(employee => employee.status === 2).length : 0;
	const numTotEvaluators = emp && emp.evaluators && emp.evaluators.employees ?
		emp.evaluators.employees.length : 0;
	const porcentEvaluators = numTotEvaluators > 0 ? (numEmployees * 100) / numTotEvaluators : 0;
	if (emp) {
		this.employee.numEmployees = numEmployees;
		this.employee.numTotEvaluators = numTotEvaluators;
		this.employee.porcentEvaluators = porcentEvaluators;
		this.showCard = true;
	}
}

function goToEvaluation(dataEmp) {
	this.$store.dispatch('evaluation360/selectedEmployee', dataEmp);
	this.goTo('evaluation-summary');
}

async function downloadReport({ type, contentType }) {
	bus.$emit(MAIN_LOADER_EVENT, { show: true, message: 'Procesando...' });
	const pollIds = this.process.pollId;
	const body = {
		processId: this.process.id,
		pollId: pollIds,
	};
	try {
		const { data: pdfData } = await this.$httpPraktiko.post('reports/evaluation/excel', body, { responseType: 'blob' });
		const blob = generateBlob(pdfData, contentType);
		showDownloadDialog(blob, 'evaluation-360', type);
		bus.$emit(MAIN_LOADER_EVENT, { show: false });
	} catch (error) {
		this.showGenericError();
		bus.$emit(MAIN_LOADER_EVENT, { show: false });
	}
}

function openEvaluators(dataE) {
	this.rows = dataE.evaluators.employees;
	this.dialog = true;
}

function closeModal(value) {
	this.dialog = value;
}

function setGender(value) {
	return value === 1 ? 'Masculino' : 'Femenino';
}

function setVote(value) {
	return value === 2 ? 'Realizado' : 'No Realizado';
}

function handleDashboard() {
	const { id, pollId } = this.process;
	this.goTo('dashboard', { params: { processId: id, pollId } });
}

function data() {
	return {
		areas: [],
		employees: [],
		// employeesFilter: [],
		area: null,
		employee: null,
		dialog: false,
		columns: [
			{ id: 1, name: 'NOMBRE DE EMPLEADO', col: 1 },
			{ id: 2, name: 'N. DOC', col: 1 },
			{ id: 3, name: 'SEXO', col: 1 },
			{ id: 4, name: 'CORREO', col: 1 },
			{ id: 5, name: 'ÁREA', col: 1 },
			{ id: 6, name: 'PUESTO', col: 1 },
			{ id: 7, name: 'Encuestas Realizadas', col: 1 },
		],
		rows: [],
		showCard: false,
	};
}

export default {
	name: 'report-evaluation',
	data,
	created,
	mounted() {
		this.loadDetails();
		// this.loadData();
	},
	components: {
		titleHeader,
		cardTool,
		downloadBtn,
		tableModal,
		modal,
	},
	methods: {
		loadData,
		goToBack,
		loadDetails,
		getAreas,
		getEmployee,
		setGender,
		setVote,
		goToEvaluation,
		downloadReport,
		openEvaluators,
		closeModal,
		handleDashboard,
	},
	computed: {
		...mapState('evaluation360', {
			process(state) {
				return pathOr(getLocalData('process'), ['process'], state.evaluation360) || [];
			},
		}),
	},
	watch: {
		employees: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.showCard = false;
				}
			},
			inmediate: true,
		},
	},
};
</script>

<style scoped>
.evaluators-table {
	border-radius: 9px !important;
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.02) !important;
	margin-top: 30px;
	max-height: 70%;
	overflow: auto;
	font: bold 90% monospace;
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/report-evaluation.vue